import { useEffect, useState } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { formatAbsolute, formatRelative } from "@/lib/format";
import { usePreferences } from "@/lib/storage";

export function RelativeTime({ iso }: { iso?: string | null }) {
  const [prefs] = usePreferences();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 30_000);
    return () => clearInterval(t);
  }, []);
  if (!iso) return <span className="text-muted-foreground">—</span>;
  const shown = prefs.timeDisplay === "absolute" ? formatAbsolute(iso, prefs.timeZone) : formatRelative(iso, now);
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <time dateTime={iso} tabIndex={0} className="tabular-nums">
          {shown}
        </time>
      </TooltipTrigger>
      <TooltipContent>
        <div>{formatAbsolute(iso, "local")}</div>
        <div className="text-muted-foreground">{formatAbsolute(iso, "utc")}</div>
      </TooltipContent>
    </Tooltip>
  );
}
